import React from 'react';
import ReactDOM from 'react-dom';
import LandingPage from '../routes/landing-page';
// global css loaded
import '../../../app/css/dist/landing-page.scss';
// import ErrorBoundary from '../utils/error-boundary';
import { StyleSheetManager } from 'styled-components';

var prerender = navigator.userAgent && navigator.userAgent.includes("Prerender");
// inject css in DOM only when google bot, or any crawler tries to access the site.
// otherwise keep it false (default behaviour of styled components)
const App = () => {
  return (
    <StyleSheetManager disableCSSOMInjection={prerender}>
      <LandingPage />
    </StyleSheetManager>
  );
};

ReactDOM.render(<App />, document.getElementById('landing-page'));
